"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _react2 = require("@chakra-ui/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwitchAxon = _ref => {
  var {
    size = "sm",
    colorScheme = "blue",
    colorLabel = "black",
    label = null,
    action,
    isChecked
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react2.FormControl, {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    mb: 0
  }, label && /*#__PURE__*/_react.default.createElement(_react2.FormLabel, {
    mb: 0,
    color: colorLabel
  }, label), /*#__PURE__*/_react.default.createElement(_react2.Switch, {
    mb: 0,
    size: size,
    colorScheme: colorScheme,
    isChecked: isChecked,
    onChange: e => action(e.target.checked)
  }));
};

var _default = SwitchAxon;
exports.default = _default;